import type { IconSvgObject } from './types';

const ArrowBigRightDashIcon: IconSvgObject = [
  ["path", { d: "M11 9V5.45377C11 4.65087 11.6509 4 12.4538 4C12.8059 4 13.1461 4.12781 13.4111 4.3597L20.2474 10.3415C20.7257 10.76 21 11.3645 21 12C21 12.6355 20.7257 13.24 20.2474 13.6585L13.4111 19.6403C13.1461 19.8722 12.8059 20 12.4538 20C11.6509 20 11 19.3491 11 18.5462V15H8C7.44772 15 7 14.5523 7 14V10C7 9.44772 7.44772 9 8 9H11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 9V15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowBigRightDashIcon;
